import {useDispatch} from "react-redux";
import {MESSAGE_ERROR} from "../constants/index.js";
import {SET_MESSAGE} from "../actions/actionTypes.js";

const sendDetailedMessage = (typeMessage, text, details) => ({
    type: SET_MESSAGE,
    typeMessage,
    text,
    details
});

export default function useErrorMessage() {
    const dispatch = useDispatch();

    return (message, details) => dispatch(sendDetailedMessage(MESSAGE_ERROR, message, details));
}